module.exports = __webpack_public_path__ + "img/room03_signos.03ffc6e8.png";